import { useOutsideClick } from '@chakra-ui/hooks';
import { Portal } from '@chakra-ui/portal';
import React, {
    useRef, useState
} from 'react';

import { useSelectorIsOneRosterActivatedSchool } from '../../state';
import { useSelectorNotificationsWithProductId } from '../notifications/notifications.selectors';
import { UserMenuButton } from './components/user-menu-button/user-menu-button';
import { useUserMenuGenerator } from './hooks/use-user-profile-menu-generator';
import { useSelectorUsername } from './user-profile.selectors';
import {
    Username,
    UserProfileWrapper,
    MenuPopper
} from './user-profile.styled';

type UserProfileProps = {
    classroomsYearGroups?: number[]
    validYearGroups: number[]
    isValidCountryCode: boolean
};

export const UserProfile = ({
    classroomsYearGroups,
    validYearGroups,
    isValidCountryCode
}:UserProfileProps) => {
    const username = useSelectorUsername();
    const [isOpen, setIsOpen] = useState(false);
    const ref = useRef(null);
    const notifications = useSelectorNotificationsWithProductId();
    const isOneRosterActivatedSchool = useSelectorIsOneRosterActivatedSchool();
    const hasNotifications = notifications.length !== 0 && !isOneRosterActivatedSchool;

    useOutsideClick({
        ref,
        handler: () => setIsOpen(false)
    });

    return (
        <UserProfileWrapper data-testid={'user-profile'} onClick={() => setIsOpen(!isOpen)} ref={ref}>
            <Portal>
                <MenuPopper display={isOpen ? 'flex' : 'none'}>
                    {useUserMenuGenerator({
                        notifications,
                        hasNotifications,
                        classroomsYearGroups,
                        validYearGroups,
                        isValidCountryCode
                    })}
                </MenuPopper>
            </Portal>
            <Username noOfLines={2}>{username}</Username>
            <UserMenuButton
                notifications={notifications}
                showNotificationCount={!isOpen && hasNotifications}
                isOpen={isOpen}
            />
        </UserProfileWrapper>
    );
};
